import { render, staticRenderFns } from "./FiltroCaixa.vue?vue&type=template&id=8c47e200&scoped=true&"
import script from "./FiltroCaixa.vue?vue&type=script&setup=true&lang=js&"
export * from "./FiltroCaixa.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c47e200",
  null
  
)

export default component.exports